/* ONE SIZE — funzioni del tema (slider, popup, catalogo, prodotto, ricerca) */
(function () {
  'use strict';
  var OS = window.OS || {};
  var ss = (function () { try { return window.sessionStorage; } catch (e) { return null; } })();
  function getJSON(store, k) { try { return JSON.parse(store.getItem(k)); } catch (e) { return null; } }
  function setJSON(store, k, v) { try { store.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- Slider hero ---------- */
  function initHero(root) {
    if (root.dataset.osReady) return; root.dataset.osReady = '1';
    var slides = root.querySelectorAll('[data-os-slide]');
    var dots = root.querySelectorAll('[data-os-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null, every = parseInt(root.dataset.autoplay, 10) || 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() { stop(); if (every > 0) timer = setInterval(function () { go(i + 1); }, every * 1000); }
    function stop() { if (timer) clearInterval(timer); }
    var p = root.querySelector('[data-os-prev]'), n = root.querySelector('[data-os-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); play(); });
    if (n) n.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.osDot, 10)); play(); }); });
    root.addEventListener('shopify:block:select', function (e) {
      var idx = Array.prototype.indexOf.call(slides, e.target); if (idx > -1) { stop(); go(idx); }
    });
    play();
  }

  /* ---------- Popup (newsletter / campagne) ---------- */
  function initPopup(el) {
    if (el.dataset.osReady) return; el.dataset.osReady = '1';
    var key = 'os-popup:' + el.dataset.key;
    function open() {
      el.hidden = false;
      var f = el.querySelector('iframe[data-src]'); if (f && !f.getAttribute('src')) f.setAttribute('src', f.dataset.src);
      document.documentElement.classList.add('os-popup-open');
    }
    function close(remember) {
      el.hidden = true; document.documentElement.classList.remove('os-popup-open');
      if (remember !== false) { try { localStorage.setItem(key, 'dismissed'); } catch (e) {} }
    }
    el.querySelectorAll('[data-os-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
    var form = el.querySelector('form'); if (form) form.addEventListener('submit', function () { setJSON(ss, 'os:lastForm', 'popup:' + el.dataset.key); });
    el._osOpen = open; el._osClose = close;
    if (window.Shopify && Shopify.designMode) return;
    if (isPosted('popup:' + el.dataset.key)) { showPosted(el); open(); return; }
    if (el.dataset.enabled !== 'true') return;
    try { if (localStorage.getItem(key)) return; } catch (e) {}
    if (window.__osPopupQueued) return; window.__osPopupQueued = true;
    setTimeout(open, (parseInt(el.dataset.delay, 10) || 0) * 1000);
  }
  function isPosted(id) {
    return /customer_posted=true/.test(location.search) && getJSON(ss, 'os:lastForm') === id;
  }
  function showPosted(scope) {
    var f = scope.querySelector('form'); if (!f) return;
    var msg = document.createElement('p'); msg.className = 'os-popup__ok os-notify__ok';
    msg.textContent = scope.dataset.success || 'Grazie! Iscrizione completata.';
    f.replaceWith(msg);
  }
  document.addEventListener('shopify:section:select', function (e) { var p = e.target.querySelector('[data-os-popup]'); if (p) { initPopup(p); p._osOpen(); } });
  document.addEventListener('shopify:section:deselect', function (e) { var p = e.target.querySelector('[data-os-popup]'); if (p && p._osClose) p._osClose(false); });

  /* ---------- Prodotto: disponibilità e "avvisami" ---------- */
  function initAvailability() {
    document.querySelectorAll('[data-os-avail]').forEach(function (box) {
      var form = box.querySelector('form');
      if (form && !form.dataset.osReady) {
        form.dataset.osReady = '1';
        form.addEventListener('submit', function () { setJSON(ss, 'os:lastForm', 'notify:' + box.dataset.product); });
      }
      if (isPosted('notify:' + box.dataset.product)) { showPosted(box); var n = box.querySelector('[data-os-notify]'); if (n) n.hidden = false; }
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        var ok = !!(v && v.available);
        document.querySelectorAll('[data-os-avail]').forEach(function (box) {
          var a = box.querySelector('[data-os-instock]'), b = box.querySelector('[data-os-notify]');
          if (a) a.hidden = !ok; if (b) b.hidden = ok;
        });
      });
    }
  }

  /* ---------- Catalogo: memoria filtri per famiglia ---------- */
  var FKEY = 'os:filters', PKEY = 'os:prevFamily';
  function persistFilters() {
    var fam = window.__osFamily; if (!fam || !ss) return;
    var p = new URLSearchParams(location.search), keep = new URLSearchParams();
    p.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'sort_by') keep.append(k, v); });
    var tag = fam === 'neutral' ? (getJSON(ss, PKEY) || 'neutral') : fam;
    setJSON(ss, FKEY, { family: tag, qs: keep.toString() });
  }
  function hookHistory() {
    if (window.__osHistoryHooked) return; window.__osHistoryHooked = true;
    ['pushState', 'replaceState'].forEach(function (m) {
      var orig = history[m];
      history[m] = function () { var r = orig.apply(this, arguments); setTimeout(persistFilters, 0); setTimeout(refreshCatalog, 50); return r; };
    });
    window.addEventListener('popstate', function () { setTimeout(persistFilters, 0); });
  }

  /* ---------- Catalogo: "Carica altri" ---------- */
  function initLoadMore() {
    var container = document.getElementById('ProductGridContainer'); if (!container) return;
    var grid = container.querySelector('#product-grid');
    var wrap = container.querySelector('.pagination-wrapper');
    container.querySelectorAll('.os-loadmore').forEach(function (n) { n.remove(); });
    if (!grid || !wrap) return;
    var current = parseInt(wrap.dataset.page, 10) || 1;
    function nextUrl(scope) {
      var found = null;
      scope.querySelectorAll('.pagination__item-arrow[href]').forEach(function (a) {
        var u = new URL(a.href, location.origin); var pg = parseInt(u.searchParams.get('page'), 10);
        if (pg > current) found = u;
      });
      return found;
    }
    var next = nextUrl(wrap); if (!next) return;
    container.classList.add('os-has-loadmore');
    var box = document.createElement('div'); box.className = 'os-loadmore';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'button button--secondary'; btn.textContent = 'Carica altri';
    box.appendChild(btn); wrap.parentNode.insertBefore(box, wrap);
    btn.addEventListener('click', function () {
      if (!next) return; btn.disabled = true; btn.textContent = 'Caricamento…';
      var sid = grid.dataset.id; if (sid) next.searchParams.set('section_id', sid);
      fetch(next.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var w2 = doc.querySelector('.pagination-wrapper');
        current = w2 ? (parseInt(w2.dataset.page, 10) || current + 1) : current + 1;
        next = w2 ? nextUrl(w2) : null;
        btn.disabled = false; btn.textContent = 'Carica altri';
        if (!next) box.remove();
      }).catch(function () { btn.disabled = false; btn.textContent = 'Riprova'; });
    });
  }

  /* ---------- Catalogo: scorciatoie prezzo ---------- */
  var PRICE_RANGES = [ ['Sotto €50', '', '50'], ['€50 – €100', '50', '100'], ['€100 – €200', '100', '200'], ['€200 – €500', '200', '500'], ['Sopra €500', '500', ''] ];
  function initPriceChips() {
    document.querySelectorAll('price-range.facets__price').forEach(function (pr) {
      if (pr.previousElementSibling && pr.previousElementSibling.classList.contains('os-price-chips')) return;
      var inputs = pr.querySelectorAll('input'); if (inputs.length < 2) return;
      var min = inputs[0], max = inputs[1];
      var box = document.createElement('div'); box.className = 'os-price-chips';
      PRICE_RANGES.forEach(function (r) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'os-chip'; b.textContent = r[0];
        if (min.value === r[1] && max.value === r[2] && (r[1] || r[2])) b.classList.add('is-active');
        b.addEventListener('click', function () {
          min.value = r[1]; max.value = r[2];
          (r[2] ? max : min).dispatchEvent(new Event('input', { bubbles: true }));
        });
        box.appendChild(b);
      });
      pr.parentNode.insertBefore(box, pr);
    });
  }


  /* ---------- Brand: link al catalogo filtrato ---------- */
  function brandUrl(v) { var q = new URLSearchParams(); q.set('filter.v.availability', '1'); q.set('filter.p.vendor', v); q.set('sort_by', 'created-descending'); return '/collections/all?' + q.toString(); }
  function brandTitle() {
    if (OS.template !== 'collection' || location.pathname.replace(/\/$/, '') !== '/collections/all') return;
    var vs = new URLSearchParams(location.search).getAll('filter.p.vendor');
    var h = document.querySelector('.collection-hero__title'); if (!h) return;
    var tn = null; h.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.nodeValue.trim()) tn = n; });
    if (!tn) return;
    if (!h.dataset.osOrig) h.dataset.osOrig = tn.nodeValue.trim();
    var want = vs.length === 1 ? vs[0] : h.dataset.osOrig;
    if (tn.nodeValue.trim() !== want) tn.nodeValue = want;
    if (vs.length === 1 && document.title !== vs[0] + ' – One Size') document.title = vs[0] + ' – One Size';
  }

  /* ---------- Card prodotto: badge con percentuale di sconto ---------- */
  function money(el) {
    if (!el) return NaN;
    var t = (el.textContent || '').replace(/[^\d,.]/g, '');
    if (t.indexOf(',') > -1) t = t.replace(/\./g, '').replace(',', '.');
    return parseFloat(t);
  }
  function pctFrom(price) {
    if (!price || !price.classList.contains('price--on-sale') || price.classList.contains('price--sold-out')) return 0;
    var was = money(price.querySelector('.price__sale .price-item--regular'));
    var now = money(price.querySelector('.price__sale .price-item--sale'));
    if (!(was > now) || !(now > 0)) return 0;
    return Math.round((was - now) / was * 100);
  }
  function saleBadges() {
    document.querySelectorAll('.card__badge .badge:not([data-os-pct])').forEach(function (b) {
      b.setAttribute('data-os-pct', '');
      var card = b.closest('.card-wrapper, .product-card-wrapper, li');
      var pct = card ? pctFrom(card.querySelector('.price')) : 0;
      if (pct > 0) b.textContent = '-' + pct + '%';
    });
    document.querySelectorAll('.price .price__badge-sale:not([data-os-pct])').forEach(function (b) {
      b.setAttribute('data-os-pct', '');
      var pct = pctFrom(b.closest('.price'));
      if (pct > 0) b.textContent = '-' + pct + '%';
    });
  }

  /* ---------- Etichetta "Taglia" al posto di "Dimensione" ---------- */
  function relabel(root) {
    (root || document).querySelectorAll('.product-form__input legend, .product-form__input .form__label, .product-option dt, .cart-item__details dt').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /\bDimensione\b/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\bDimensione\b/, 'Taglia');
      });
    });
  }
  /* ---------- Carrello: vantaggi ---------- */
  function cartPerks() {
    document.querySelectorAll('.cart-drawer__footer, .cart__footer .cart__blocks').forEach(function (f) {
      if (f.querySelector('.os-cart-perks')) return;
      var p = document.createElement('p'); p.className = 'os-cart-perks';
      p.style.cssText = 'margin:1rem 0 0;font-size:1.25rem;color:rgb(var(--os-lime));display:flex;flex-wrap:wrap;gap:.4rem 1.6rem;';
      p.innerHTML = '<span>✓ Spedizione gratuita in tutta Italia</span><span>✓ Prodotti 100% autentici</span>';
      f.appendChild(p);
    });
  }
  function watchDom() {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { saleBadges(); relabel(); brandTitle(); cartPerks(); }, 40); })
      .observe(document.body, { childList: true, subtree: true });
  }

  function refreshCatalog() { initLoadMore(); initPriceChips(); brandTitle(); }
  function initCatalog() {
    if (!document.getElementById('ProductGridContainer')) return;
    persistFilters(); hookHistory(); refreshCatalog();
    var target = document.getElementById('ProductGridContainer');
    new MutationObserver(function () { clearTimeout(window.__osCatT); window.__osCatT = setTimeout(refreshCatalog, 60); })
      .observe(target, { childList: true });
    var facets = document.querySelector('.facets-wrapper, #main-collection-filters, .facets-container');
    if (facets) new MutationObserver(function () { clearTimeout(window.__osFacT); window.__osFacT = setTimeout(initPriceChips, 60); })
      .observe(facets, { childList: true, subtree: true });
  }

  /* ---------- Ricerca predittiva: brand e taglie ---------- */
  var APPAREL = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '2xl', '3xl'];
  function buildExtras(term) {
    var tokens = term.toLowerCase().trim().split(/\s+/).filter(Boolean); if (!tokens.length) return null;
    var vendors = (OS.vendors || []).filter(function (v) { var lv = v.toLowerCase(); return tokens.some(function (t) { return t.length > 1 && lv.indexOf(t) > -1; }); }).slice(0, 4);
    var shoe = [], apparel = [];
    tokens.forEach(function (t) {
      var tt = t.replace(',', '.');
      if (/^\d{2}(\.5)?$/.test(tt)) shoe.push(tt);
      if (APPAREL.indexOf(t) > -1) apparel.push(t.toUpperCase());
    });
    if (!vendors.length && !shoe.length && !apparel.length) return null;
    var wrap = document.createElement('div'); wrap.className = 'os-ps-extra';
    function group(title, links) {
      var g = document.createElement('div');
      var h = document.createElement('p'); h.className = 'os-ps-extra__head'; h.textContent = title; g.appendChild(h);
      var c = document.createElement('div'); c.className = 'os-ps-extra__chips';
      links.forEach(function (l) { var a = document.createElement('a'); a.href = l[1]; a.textContent = l[0]; c.appendChild(a); });
      g.appendChild(c); wrap.appendChild(g);
    }
    if (vendors.length) group('Brand', vendors.map(function (v) { return [v, brandUrl(v)]; }));
    var sizes = [];
    shoe.forEach(function (s) { var q = new URLSearchParams(); q.set('filter.v.availability', '1'); q.set('filter.v.option.numero di scarpa', s); sizes.push(['Numero ' + s, '/collections/scarpe?' + q.toString()]); });
    apparel.forEach(function (s) { var q = new URLSearchParams(); q.set('filter.v.availability', '1'); q.set('filter.v.option.dimensione', s); sizes.push(['Taglia ' + s, '/collections/abbigliamento?' + q.toString()]); });
    if (sizes.length) group('Taglie disponibili', sizes);
    return wrap;
  }
  function initPredictiveExtras() {
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      if (ps.dataset.osReady) return; ps.dataset.osReady = '1';
      var input = ps.querySelector('input[type="search"], input[name="q"]');
      var results = ps.querySelector('[data-predictive-search]'); if (!input || !results) return;
      new MutationObserver(function () {
        var holder = results.querySelector('#predictive-search-results'); if (!holder || holder.querySelector('.os-ps-extra')) return;
        var extra = buildExtras(input.value || ''); if (extra) holder.insertBefore(extra, holder.firstChild);
      }).observe(results, { childList: true, subtree: true });
    });
  }

  function init() {
    document.querySelectorAll('[data-os-hero]').forEach(initHero);
    document.querySelectorAll('[data-os-popup]').forEach(initPopup);
    initAvailability(); initCatalog(); initPredictiveExtras();
    saleBadges(); relabel(); brandTitle(); cartPerks(); watchDom();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-os-hero]').forEach(initHero);
    e.target.querySelectorAll('[data-os-popup]').forEach(initPopup);
    refreshCatalog();
  });
})();
